import { ClickAwayListener, Popper } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import ButtonExpander from 'components/Buttons/ButtonExpander';
import MuiClickable from 'components/MuiExtras/MuiClickable';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import QuillContainer from 'components/Quill/QuillContainer';
import HTMLReactParser from 'html-react-parser';
import * as React from 'react';
import UserShortProfile from 'views/User/Components/UserShortProfile';

const styles = createStyles({
    clampLinesButton: {
        background: "none",
        border: 0,
        color: "red",
        cursor: "pointer",
        padding: 0,
        "&:hover": {
            borderBottom: "1px solid red"
        }
    },
});

interface IState {
    dialog: any;
}

interface IProps {
    text: string;
    expanded: boolean;
    ellipsis?: string;
    moreText?: string | React.ReactNode;
    lessText?: string | React.ReactNode;
    className?: string;

    /** Estilo aplicado ao botão de expandir */
    buttonClassName?: string;

    /** Estilo aplicado a uma imagem que for encontrada no texto */
    imageClassName?: string;

    onTextExpandedChange?: (expanded: boolean) => void;
    onImageClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
}

type Props = IProps & WithStyles<typeof styles>;

class QuillTextExpander extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            dialog: null
        };
    }

    static defaultProps: Partial<Props> = {
        ellipsis: '...',
        moreText: 'Mais',
        lessText: 'Menos'
    };

    private handleCloseDialog = () => {
        this.setState({ dialog: null });
    };

    private openDialog(id: string, achorEl: any) {
        this.setState({
            dialog: (
                <Popper
                    disablePortal={false}
                    open={true}
                    anchorEl={achorEl}
                    placement="bottom-start"
                >
                    <ClickAwayListener onClickAway={this.handleCloseDialog}>

                        <UserShortProfile userId={id} onClose={this.handleCloseDialog} />

                    </ClickAwayListener>
                </ Popper>
            )
        });
    }

    private handleExpand = () => {
        if (this.props.onTextExpandedChange) this.props.onTextExpandedChange(!this.props.expanded);
    };

    private textWillContractedOrExpanded() {
        return this.props.onTextExpandedChange && this.props.expanded != null;
    }

    private getButton() {

        if (!this.textWillContractedOrExpanded())
            return null;

        // WORKITEM 585: não mostrar "Ver menos" nos cards.
        // Utilizar o ícone de "contrair" para executar essa operação.
        if (this.props.expanded)
            return null;

        return (
            <ButtonExpander
                moreText={this.props.moreText}
                lessText={this.props.lessText}
                expanded={this.props.expanded}
                className={this.props.buttonClassName || this.props.classes.clampLinesButton}
                onClick={this.handleExpand}
            />
        );
    }

    render() {
        if (this.props.text == null) {
            return null;
        }

        const body = HTMLReactParser(this.props.text, {
            replace: (domNode: any) => {
                if (domNode.attribs) {
                    if (domNode.attribs && domNode.attribs.class === 'mention') {
                        return (
                            <span className="mention">
                                <span>
                                    <span className="ql-mention-denotation-char">{domNode.attribs["data-denotation-char"]}</span>
                                    <a
                                        href={null}
                                        className="ql-mention-link"
                                        onClick={
                                            (e) => this.openDialog(domNode.attribs["data-id"], e.currentTarget)
                                        }
                                    >
                                        {domNode.attribs["data-value"]}
                                    </a>
                                </span>
                            </span>);
                    }

                    if (domNode.attribs && domNode.name === 'img' && this.props.onImageClick != null) {
                        return (
                            <img
                                onClick={this.props.onImageClick}
                                src={domNode.attribs.src}
                                height={domNode.attribs.height}
                                width={domNode.attribs.width}
                                className={this.props.imageClassName}
                                alt="Editor Image"
                            />
                        );
                    }

                    if (domNode.attribs && domNode.attribs.contenteditable) {
                        delete domNode.attribs.contenteditable;
                        return domNode;
                    }
                }
                return null;
            }
        });

        return (
            <>
                {this.state.dialog}

                <div className={this.props.className}>
                    <MuiContainer margin="dense">
                        <QuillContainer viewOnly>
                            {
                                this.textWillContractedOrExpanded() && !this.props.expanded
                                    ? (
                                        <MuiClickable onClick={this.handleExpand}>
                                            {body}
                                        </MuiClickable >
                                    )
                                    : body
                            }
                        </QuillContainer>
                    </MuiContainer>
                    {this.getButton()}
                </div>
            </>
        );
    }
}

export default withStyles(styles)(QuillTextExpander);